import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef, useState } from 'react';
import { getLink, getUserType } from '../../utils/common';
import { SOCIAL_PLATEFORM, TOOLTIP_STYLES, getFixedValue, hideScrollbarCss } from '../../utils/constant';
import Brands from './Brands';
import Posts from './Posts';
import profilePlatformIcon from '../../assets/images/icons/profilePlatformIcon.svg'
import imageIconBlack from '../../assets/images/icons/imageIconBlack.svg'
import tagIcon from '../../assets/images/icons/tagIcon.svg'
import linkIcon from '../../assets/images/icons/linkIcon.svg'
import instagramIcon from '../../assets/images/icons/instaIcon.svg'
import youtubeIcon from '../../assets/images/icons/YouTube2.svg'
import infoIcon from '../../assets/images/icons/infoIcon.svg'
import { useSelector } from 'react-redux';
const ProfileSummary = ({ details, userDetails }) => {
    const [hashtags, setHashTags] = useState([]);
    const [showAllHastags, setShowAllHastags] = useState(false);
    const [childElementIdForScroll, setChileElementIdForScroll] = useState("#platforms")
    const contentRef = useRef(null);
    const {isScreenZoomed} = useSelector(state=>state.commonSlice);
    const onSmoothClick = (e, href) => {
        const id = href.replace("#", "")
        const parentEle = document.getElementById('parent');
        const childEle = document.getElementById(id);
        setChileElementIdForScroll('#' + id);
        if (parentEle && childEle) {
            parentEle.scrollTop = childEle.offsetTop
            e.preventDefault()
            parentEle.scrollIntoView({
                behavior: "smooth",
            })
        }
    }
    useEffect(() => {
        const hashtags = [];
        details.forEach((item) => {
            if (item?.content?.hashtags?.length > 0) {
                hashtags.push(...item.content.hashtags)
            }
        })
        setHashTags(hashtags)
    }, [])
    const getIndex = details.findIndex((v) => v?.content?.topMostPost?.length > 0);
    const links = [{ label: 'Platforms', href: '#platforms', icon: profilePlatformIcon }, { label: 'Content', href: '#content', icon: imageIconBlack }, { label: 'Brands', href: '#brands', icon: tagIcon }]
    const userType = getUserType();
    return (
        <>
            <Stack direction={"row"} padding={'0px 16px'} position={"relative"} border={'0px solid red'} sx={{ height : userType === 'admin' ? (isScreenZoomed ? '50vh' : '60vh') : (isScreenZoomed ? '65vh' : '69vh')}}>
                <Box sx={{ width: '15%', height: '100%', position: 'sticky', top: 0, border: '0px solid blue', paddingTop: '20px' }}>
                    {/* navbar */}
                    <Stack direction={"column"} gap={2}>
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => onSmoothClick(e, l.href)}
                                style={{ display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }}
                            >
                                <img src={l.icon} alt={l.icon} style={{
                                    height: '20px', width: '20px', filter:
                                        childElementIdForScroll === l.href
                                            ? "brightness(0) saturate(100%) invert(38%) sepia(95%) saturate(7485%) hue-rotate(202deg) brightness(103%) contrast(104%)"
                                            : "brightness(0)",
                                }} />
                                <Typography fontSize={16} fontWeight={400} color={childElementIdForScroll === l.href ? "var(--color-blue)" : '#726C6C'}>{l.label}</Typography>
                            </a>
                        ))}
                    </Stack>
                </Box>
                <Box sx={{
                    width: '85%', height: '100%', border: '0px solid red', overflowY: 'scroll', position: 'relative', borderLeft: '1px solid #F0F0F0', 
                    scrollBehavior: 'smooth', overscrollBehavior: 'contain', padding: '0px 20px 0 40px'
                }} id="parent" ref={contentRef} >
                    {/* content box */}
                    <Box id='platforms' paddingTop={'20px'}>
                        {details?.map((item, index) => (
                            <Box sx={{ boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.10)', background: 'white', borderRadius: '8px', width: '100%', padding: '20px', marginY: index === 1 ? '40px' : '0', borderBottom: item.platformType === 'instagram' ? '2px solid var(--color-blue)' : '2px solid #F00' }}>
                                <Stack direction={"row"} gap={1} justifyItems={"flex-start"} alignItems={"center"} paddingBottom={'20px'}>
                                    <img src={item.platformType === 'instagram' ? instagramIcon : youtubeIcon} alt={item.platformType === 'instagram' ? instagramIcon : youtubeIcon} style={{ height: '24px', width: '24px' }} />
                                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: 'black', }}>{item.handleName}</Typography>
                                    <a href="/" onClick={(e) => { e.preventDefault(); window.open(getLink(item.platformType, item.handleName), "_blank"); }} target='_blank'><img src={linkIcon} alt={linkIcon} style={{ height: '18px', width: '18px' }} /></a>
                                </Stack>
                                <Stack direction={"row"} width={"100%"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? "Subscribers" : "Followers"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item.followers) || 'N/A'}</Typography>
                                    </Stack>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? "Total Videos" : "Avg. Likes"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{SOCIAL_PLATEFORM.YOUTUBE === item.platformType ? (item?.content?.post?.length || 'N/A') : getFixedValue(item?.Engagement?.posts?.avg_likes) || "N/A"}</Typography>
                                    </Stack>
                                    {SOCIAL_PLATEFORM.YOUTUBE === item.platformType && <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{"Avg. Likes"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_likes) || 'N/A'}</Typography>
                                    </Stack>}
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>Avg. Comments</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_comments) || 'N/A'}</Typography>
                                    </Stack>
                                    <Stack direction={'column'} gap={1} >
                                        <Typography fontSize={14} fontWeight={300} color={"black"}>{SOCIAL_PLATEFORM.INSTAGRAM !== item.platformType ? "Avg. Views" : "Avg. Reel Views"}</Typography>
                                        <Typography fontSize={14} fontWeight={500} color={"black"}>{getFixedValue(item?.Engagement?.posts?.avg_views) || "N/A"}</Typography>
                                    </Stack>
                                    {SOCIAL_PLATEFORM.INSTAGRAM === item.platformType &&
                                        <Stack direction={'column'} gap={1} >
                                            <Typography fontSize={14} fontWeight={300} color={"black"}>Engagement Rate &nbsp;<Tooltip componentsProps={TOOLTIP_STYLES} arrow title="Engagement rate shows the percent of the audience who engages with the content posted by this influencer.
 It is calculated as average engagement (likes + comments) divided by follower count, and then multiply by 100 to give you a percentage." placement="top-start"><img src={infoIcon} alt='infoicon' style={{ width: '20px', height: '20px' }} /></Tooltip></Typography>
                                            <Typography fontSize={14} fontWeight={500} color={"black"}>{item?.overview?.engagement_rate?.toFixed(2) + "%" || "N/A"}</Typography>
                                        </Stack>
                                    }
                                </Stack>
                            </Box>
                        ))}
                    </Box>
                    <Box id='content' paddingTop={"20px"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <img src={imageIconBlack} style={{ width: '24px', height: '24px' }} alt={imageIconBlack} />
                            <Typography fontSize={20} fontWeight={600} color={"black"}>Content</Typography>
                        </Stack>
                        <Stack direction={"row"} gap={1} alignItems={"center"} marginTop={'24px'}>
                            <Typography fontSize={16} fontWeight={400} color={"#726C6C"}>HASHTAGS</Typography>
                            <img src={infoIcon} style={{ width: '18px', height: '18px', display: 'none' }} alt={imageIconBlack} />
                        </Stack>
                        <Grid container>
                            {
                                (Array.isArray(hashtags) ? [...hashtags].sort((a, b) => b.value - a.value).slice(0, showAllHastags ? 26 : 11) : []).map((item, index) => (
                                    <Grid key={item?.text} item xs={4} sx={{ height: '50px', padding: '0 30px 0 0', border: '0px solid red' }}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #F0F0F0', paddingY: '20px', height: '100%' }}><Stack direction="row" gap={1} alignItems='center'>
                                            <Typography fontSize="16px" fontWeight={400}>{index + 1}.</Typography>
                                            <Typography fontSize="16px" fontWeight={400}>{item?.text}</Typography>
                                        </Stack> <Typography color="#9F9C9C" fontSize="14px" fontWeight={400}>{item?.value} Post</Typography></Stack>
                                    </Grid>
                                ))
                            }
                            {hashtags?.length > 11 && <Grid item xs={4} sx={{ height: '50px', padding: 0 }}>
                                <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ paddingY: '20px', height: '100%', borderBottom: '1px solid #F0F0F0', }}>
                                    <Button onClick={() => { setShowAllHastags(prev => !prev); console.log('dhbhd') }} disableRipple sx={{
                                        "&:hover": {
                                            background: 'none'
                                        }
                                    }}>
                                        <Typography sx={{ fontSize: "16px", fontWeight: 400, color: 'var(--color-blue)' }}>{showAllHastags ? "See Less" : "See All"}
                                        </Typography>
                                    </Button>
                                </Stack>
                            </Grid>}
                        </Grid>
                        <Posts details={details[getIndex]} flag={false} />
                    </Box>
                    <Box id='brands' paddingTop={"60px"}>
                        <Brands brands={details?.map((v) => v?.Brands || [])?.flat().filter((v, i, self) => i == self.findIndex((vv) => v.Name === vv.Name))} handleId={0} userId={0} />
                    </Box>
                </Box>
            </Stack>
        </>
    );
};
export default ProfileSummary;
